module.exports = __webpack_public_path__ + "img/f6.ea79d39b.png";